"use client"
import { useState,useEffect } from "react"
import { Calendar, FileText } from "lucide-react"
import { useAuth } from "../../contexts/AuthContext"
import axios from 'axios';
import { useNavigate } from "react-router-dom"

interface ReportDetails { 
  MycName: string | null
  StName: string | null
  CLastName: string
  CFirstName: string
  PPON: string
  PSchedDt: string
  Carrier: string
  REC: string
  MessageDate: string
  StgDueDt: string | null
  CorpName: string | null
  PpwNote: string | null
  MessageDesc: string | null
  SchStartdate: string
  SchEnddate: string | null
  MaterialStatus: string | null
  MtpName: string | null
  ScheduleStatus: string
  lookupStatus: string
  StgRcvdDt: string 
  CustomerId:string 
}


export default function SummaryReport() {
   const navigate = useNavigate()
  const { user } = useAuth()
  const [loading, setLoading] = useState(true); 
    const [ReportDetails, setReportDetail] = useState<ReportDetails[]>([])

  // const [dateFilter, setDateFilter] = useState("")
  // const [statusFilter, setStatusFilter] = useState("")
 
useEffect(() => {
  if (!user?.Store) return; // don't fetch until we have Store

  const fetchReportData = async () => {
    try {
      debugger;
      // const res = await axios.get<ReportDetails[]>(
      //   `https://qaacsstoreapi.acsouth.com:443/api/summary?vstore=${user?.Store}`
      // );
      //  const res = await axios.get<ReportDetails[]>(
      //   `https://devprodapi.acsouth.com/api/summary?vstore=${user?.Store}`
      // );
      //PRODUCTION
      const res = await axios.get<ReportDetails[]>(
              `https://acsstoreapi.acsouth.com:443/api/summary?vstore=${user?.Store}`
            );
      // debugger;

      //DR Activity
      // const res = await axios.get<ReportDetails[]>(
      //         `https://dracsstoreapi.acsouth.com:443/api/summary?vstore=${user?.Store}`
      //       );
      debugger;
      const cleaned = res.data.filter(item => item.PPON?.trim());
      setReportDetail(cleaned);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  fetchReportData();
}, [user?.Store]);


  
  // const filteredData = ReportDetails.filter((item) => {
  //   const dateMatch = !dateFilter || item.scheduleDate.includes(dateFilter)
  //   const statusMatch = !statusFilter || item.status === statusFilter
  //   return dateMatch && statusMatch
  // })

  // const getStatusColor = (StatusDesc: string) => {
  //   switch (StatusDesc) {
  //     case " Customer is not ready":
  //       return "bg-green-100 text-green-800"
  //     case "On Hold":
  //       return "bg-yellow-100 text-yellow-800"
  //     case "Scheduled":
  //       return "bg-blue-100 text-blue-800"
  //     case "Awaiting material":
  //       return "bg-gray-100 text-gray-800"
  //     default:
  //       return "bg-gray-100 text-gray-800"
  //   }
  // }

  
  const handleCustomerClick = (customerId: string) => {
    navigate(`/dashboard/customer-details/${customerId}`)
  }

  if (loading) return <p>Loading...</p>;

  return (
    <div className="p-4 lg:p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-6">
          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4 lg:mb-0">Summary Report</h1>
          <div className="text-sm text-gray-500">
            <span className="font-medium">Read Only</span> - Total Records: {ReportDetails.length}
          </div>
        </div>

        {/* Filters */}
        {/* <div className="bg-white rounded-lg shadow-md p-4 lg:p-6 mb-6">
          <div className="flex items-center mb-4">
            <Filter className="h-5 w-5 text-gray-400 mr-2" />
            <h2 className="text-lg font-semibold text-gray-900">Filters</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
              <input
                type="date"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={dateFilter}
                onChange={(e) => setDateFilter(e.target.value)}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
              <select
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">All Statuses</option>
                <option value="Scheduled">Scheduled</option>
                <option value="In Progress">In Progress</option>
                <option value="Completed">Completed</option>
                <option value="Pending">Pending</option>
              </select>
            </div>
            <div className="md:col-span-2 flex items-end">
              <button
                onClick={() => {
                  setDateFilter("")
                  setStatusFilter("")
                }}
                className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 border border-gray-300 rounded-md hover:bg-gray-50"
              >
                Clear Filters
              </button>
            </div>
          </div>
        </div> */}

        {/* Summary Stats */}
        {/* <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <div className="bg-white p-4 rounded-lg shadow-md text-center">
            <div className="text-2xl font-bold text-blue-600">
              {filteredData.filter((item) => item.status === "Scheduled").length}
            </div>
            <div className="text-sm text-gray-600">Scheduled</div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-md text-center">
            <div className="text-2xl font-bold text-yellow-600">
              {filteredData.filter((item) => item.status === "In Progress").length}
            </div>
            <div className="text-sm text-gray-600">In Progress</div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-md text-center">
            <div className="text-2xl font-bold text-green-600">
              {filteredData.filter((item) => item.status === "Completed").length}
            </div>
            <div className="text-sm text-gray-600">Completed</div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-md text-center">
            <div className="text-2xl font-bold text-gray-600">
              {filteredData.filter((item) => item.status === "Pending").length}
            </div>
            <div className="text-sm text-gray-600">Pending</div>
          </div>
        </div> */}

        {/* Report Table */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Customer Details
                  </th>
                  <th className="px-4 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    PO Number
                  </th>
                  <th className="px-4 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Material Status
                  </th>
                  <th className="px-4 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Job Type
                  </th>
                  <th className="px-4 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Schedule Date
                  </th>
                  <th className="px-4 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {ReportDetails.map((item, index) => (
                  <tr key={`${item.PPON}-${index}`} onClick={() => handleCustomerClick(item.CustomerId)} className="hover:bg-gray-50">
                    <td className="px-4 lg:px-6 py-4">
                      <div>
                        <div className="text-sm font-medium text-gray-900">{item.CFirstName} {item.CLastName}</div>
                        <div className="text-xs text-gray-400">Material : {item.MtpName}</div>
                      </div>
                    </td>
                    <td className="px-4 lg:px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center text-sm text-gray-900">
                        <FileText className="h-4 w-4 mr-2 text-gray-400" />
                        {item.PPON}
                      </div>
                    </td>
                    
                    <td className="px-4 lg:px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.MaterialStatus}</td>

                    <td className="px-4 lg:px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.ScheduleStatus}</td>

                    <td className="px-4 lg:px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center text-sm text-gray-900">
                        <Calendar className="h-4 w-4 mr-2 text-gray-400" />
                        {item.SchStartdate}  
                      </div> 
                       <div className="flex items-center text-sm text-gray-900">
                        <Calendar className="h-4 w-4 mr-2 text-gray-400" />
                        {item.SchEnddate}  
                      </div> 
                    </td>
                    <td className="px-4 lg:px-6 py-4 whitespace-nowrap">
                      {/* { <span
                        className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full`}
                      >
                        {item.ScheduleStatus}
                      </span> } */}

                      <span
                                  className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                                    item.PSchedDt !== "" 
                                      ? "bg-green-100 text-green-800"
                                      : item.PSchedDt === ""  && item.lookupStatus !== "" 
                                      ? "bg-yellow-100 text-yellow-800"
                                      : item.PSchedDt === ""  && item.lookupStatus === "" 
                                      ? "bg-red-100 text-red-800"
                                      : "bg-blue-100 text-blue-800"
                                  }`}
                                >
                                 {
                                    item.PSchedDt !== "" 
                                      ? "Scheduled"
                                      : item.PSchedDt === ""  && item.lookupStatus !== "" 
                                      ?  item.lookupStatus
                                      : "Not Scheduled"                                     
                                  }
                                </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* No Results */}
        {ReportDetails.length === 0 && (
          <div className="bg-white rounded-lg shadow-md p-8 text-center">
            <FileText className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">No records found</h3>
            <p className="text-gray-600">Try adjusting your filters to see more results.</p>
          </div>
        )}
      </div>
    </div>
  )
}
